module.exports = __webpack_public_path__ + "static/media/exams.927028b0.svg";